export default {
  source: {
    url: "mapbox://mepa1363.3dhh8ims"
  },
  layer: {
    id: "accessibility-parks",
    source: "pickyourplace_parks",
    minZoom: 5,
    maxZoom: 22,
    color: "#005a32"
  }
};
